import forEach from 'lodash/forEach';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfig, useMenuItemRenderer, useOnClickOutside } from '../../hooks';
import { useStores } from '../../stores';
import { MAIN_MENU_ITEM_GET_HOT_TOPICS, MAIN_MENU_ITEM_GET_TOP_QUESTIONS } from '../../utilities';
import DropDown from '../DropDown';
import DropDownItem from '../DropDownItem';
import IconButton from '../IconButton';
import MenuIcon from '../Icons/Menu';
import { ControlsItem } from './Controls';

const MainMenu = ({ items = [], ...props }) => {
  const ref = React.useRef();
  const { i18n, t } = useTranslation();
  const [isOpen, setOpen] = React.useState(false);
  const { network, bot } = useStores();
  const {
    topFaqs,
    header: {
      title: { color, iconColor }
    },
    window: { colors }
  } = useConfig();
  useOnClickOutside(ref, () => setOpen(false));
  const renderMenuItem = useMenuItemRenderer();

  // filter for HotTopics and Popular Questions
  const filteredItems = [];
  forEach([...items], item => {
    if (item.functionName) {
      // Hot Topics
      if (
        (!topFaqs.hotTopicsCount && item.functionName === MAIN_MENU_ITEM_GET_HOT_TOPICS) ||
        (topFaqs.hotTopicsCount &&
          !bot.hotTopics.length &&
          item.functionName === MAIN_MENU_ITEM_GET_HOT_TOPICS)
      ) {
        return null;
      }

      // Popular Questions
      if (!bot.topQuestions.length && item.functionName === MAIN_MENU_ITEM_GET_TOP_QUESTIONS) {
        return null;
      }
    }
    filteredItems.push(item);

    return filteredItems;
  });

  return (
    <ControlsItem ref={ref} {...props}>
      <IconButton
        disabled={network.isOffline || network.isSlowConnection}
        onClick={() => setOpen(!isOpen)}
        title={i18n.exists('altText.menu') ? t('altText.menu') : ''}
      >
        <MenuIcon fill={iconColor || color} />
      </IconButton>
      {isOpen && (
        <DropDown>
          {filteredItems
            .sort((a, b) => a.position - b.position)
            .map((item, idx) => (
              <DropDownItem
                key={idx}
                onClick={() => setOpen(false)}
                textColor={colors.main}
                hoverTextColor={colors.accent}
              >
                {renderMenuItem(item, idx)}
              </DropDownItem>
            ))}
        </DropDown>
      )}
    </ControlsItem>
  );
};

export default observer(MainMenu);
